<template>
  <button class="btn" :class="btnClass">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'AppBtn',
  props: {
    btnClass: {
      type: String,
      default: 'btn_primary',
    },
  },
}
</script>

<style lang="scss">
.btn {
  display: grid;
  place-items: center;
  border-radius: 16px;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
  @media screen and (max-width: 1220px) {
    // border-radius: 12px;
  }

  &_primary {
    background-color: color(green-main);
    color: color(white);

    &:hover {
      background-color: lighten(color(green-main), 10);
    }
  }

  &_secondary {
    background-color: color(green-light);
    color: color(green-second);

    &:hover {
      background-color: darken(color(green-light), 10);
    }
  }

  &_orange {
    background-color: color(orange);
    color: color(orange);

    &:hover {
      background-color: lighten(color(orange), 10);
    }
  }

  &_blue {
    background-color: color(blue);
    color: color(white);

    &:hover {
      background-color: lighten(color(blue), 10);
    }
  }

  &_grey {
    background-color: color(dark-grey);
    color: color(white);

    &:hover {
      background-color: lighten(color(dark-grey), 10);
    }
  }

  &_grey-second {
    background-color: color(grey-second);
    color: color(white);

    &:hover {
      background-color: darken(color(grey-second), 10);
    }
  }

  &_underline {
    padding: 0;
    padding-bottom: 4px;
    border-bottom: 2px solid currentColor;
    color: color(green-second);
    background-color: transparent;
    border-radius: 0;

    &-grey {
      @extend .btn_underline;
      color: #707372;

      &:hover {
        color: color(green-second) !important;
      }
    }
    &:hover {
      color: lighten(color(green-second), 10);
    }

    &:disabled {
      color: color(dark-grey);
    }

    & .disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &.disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &_inactive {
    opacity: 0.4;
  }
}
</style>
